export default __webpack_public_path__ + "static/media/time-icon.b619b7cf.svg";